import './DispatchBoard.scss';
import { CardBody, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHardHat,
} from '@fortawesome/free-solid-svg-icons';
import { crewLeadLabel, weekdayShort } from '@s20/i18n';
import { formatOffsetInTimeZone } from '@s20/common/util/date';
import {
    ActivityIcons, EventStatus, MomentTimeFormat,
} from '../Common';

const eventTime = (occurredOn, timeZone) => {
    if (!occurredOn) {
        return '';
    }
    const time = formatOffsetInTimeZone(occurredOn, MomentTimeFormat.AnteTwelveHour, timeZone);
    return time;
};

const DispatchEmployeeEvents = (props) => {
    const {
        job, selectedWeekRangeDays, tenantSettings,
    } = { ...props };
    const crewLead = crewLeadLabel(tenantSettings);

    return (
        <div className="jobAssignmentsTableContainer">
            <table className="table table-sm jobAssignmentsTable mb-0">
                <thead>
                    <tr>
                        {
                            (selectedWeekRangeDays ?? []).map((day) => (
                                <th key={day}>
                                    <div className="w-100 job-assignment-table-header d-flex flex-row flex-nowrap">
                                        <span className="text-left flex-fill">{weekdayShort(day.getDay())}</span>
                                        <span className="text-muted">{`${day.getMonth() + 1}/${day.getDate()}`}</span>
                                    </div>
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {
                            (selectedWeekRangeDays ?? []).map((day) => {
                                const assignments = job.assignments[day.getDay()].staff ?? job.assignments[day.getDay()].cancelledAssignments;
                                return (
                                    <td key={day}>
                                        <div className="assignmentsWrapper">
                                            <div className="assignments">
                                                {
                                                    assignments.map((a) => {
                                                        const assignment = a.cancelledOn ? a : a.assignment;
                                                        if (assignment) {
                                                            return (
                                                                <div
                                                                    className="card staffCard compact"
                                                                    key={a.id}
                                                                >
                                                                    <CardBody>
                                                                        <CardTitle className="text-left d-flex flex-row justify-content-between align-items-center">
                                                                            <span className="d-flex flex-row flex-fill justify-content-between align-items-center">
                                                                                <span>
                                                                                    {
                                                                                        !!a.isCrewLead
                                                                                        && (
                                                                                            <FontAwesomeIcon
                                                                                                icon={faHardHat}
                                                                                                className="mr-1 crewLeadBadge"
                                                                                                style={{ color: '#ff8d00' }}
                                                                                                title={`Employee is ${crewLead}`}
                                                                                            />
                                                                                        )
                                                                                    }
                                                                                    {`${assignment.name ?? assignment.assignedEmployee}`}

                                                                                    {a.assignmentEvents?.length > 0 ? (
                                                                                        a.assignmentEvents.map((ev, index) => (
                                                                                            <div key={index}>
                                                                                                <span
                                                                                                    className={`d-block mt-1 ${ev.description == EventStatus.NoShow ? 'text-danger' : ''
                                                                                                        }`}
                                                                                                >
                                                                                                    <FontAwesomeIcon
                                                                                                        icon={ActivityIcons[ev.description]}
                                                                                                        className="mr-1"
                                                                                                    />
                                                                                                    <span>{eventTime(ev.occurredOn, ev.timeZone ?? job.timeZone)}: {ev.description}</span>
                                                                                                </span>

                                                                                                {Boolean(ev.notes) && (
                                                                                                    <span className="d-block ml-4 text-muted small">
                                                                                                        <em>{ev.notes}</em>
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        ))
                                                                                    ) : (
                                                                                        <span className="d-block mt-1">No events recorded.</span>
                                                                                    )}
                                                                                </span>
                                                                                <div className="d-flex flex-column">
                                                                                    <span
                                                                                        className="text-right assignment-status-label mr-2"
                                                                                    >
                                                                                        {assignment.confirmationStatusName ?? assignment.jobAssignmentCancellationType}
                                                                                    </span>
                                                                                </div>
                                                                            </span>
                                                                        </CardTitle>
                                                                    </CardBody>
                                                                </div>

                                                            );
                                                        }
                                                    })}
                                            </div>
                                        </div>
                                    </td>
                                );
                            })}
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default DispatchEmployeeEvents;
